import React from 'react';
import { Badge } from 'reactstrap';
import { Row, Col, Card, ListGroup, ListGroupItem, Button, Container } from 'react-bootstrap';
import { Accordion } from 'react-bootstrap'
import free from './free.png';
import pro from './Pro.png';
import enterprise from './Enterprise.png';
import SimpleFooter from './views/examples/components/Footers/SimpleFooter';


class Pricing extends React.Component {

  render() {

    return (
      <div className='pricing' style={{ backgroundColor: 'white', height: '95vh' }}>
        <div className="section row justify-content-center" id="heading" style={{ paddingTop: '150px' }}>
          <div className="col text-center">
            <h1>Find the perfect plan for your Circle</h1>
            <p>Pay monthly or annually and cancel at any time.</p>
          </div>
        </div>
        <div className="section" style={{ padding: '20px', marginTop: '30px' }} >
          {/* <div style = {{backgroundColor: "gray", height: '70vh', marginTop: "50px", borderRadius: "10px"}}>
      </div> */}
          <Container style={{ backgroundColor: "#F8F9FB", padding: '40px', height: 'fit-content', borderRadius: '20px' }}>
            <div className="row justify-content-center">
              <div className="col text-center">
                <h4 style={{ color: "#575757" }}>Pricing Options</h4>
              </div>
            </div>
            <hr></hr>
            <Row style={{ marginTop: '40px' }}>
              <Col align="center">
                <Card className="shadow" style={{ width: '18rem', border: "none" }}>
                  <Card.Img variant="top" src={free} />
                  <Card.Body>
                    <Card.Title style={{ fontSize: '25px' }}> Free for 3 months</Card.Title>
                    {/* <Card.Text style ={{ color: "gray"}}>
                  Free Trial
                </Card.Text> */}
                    <Card.Text>
                      <ListGroup className="list-group-flush">
                        <ListGroupItem>Access to all features</ListGroupItem>
                        <ListGroupItem>50 Transactions/month</ListGroupItem>
                        <ListGroupItem>Suggested up to groups of 15</ListGroupItem>
                      </ListGroup>
                    </Card.Text>
                    <a href="/#/contactus"><Button style={{ backgroundColor: "#867fd7", border: 'none' }}>Request a Demo</Button></a>
                  </Card.Body>
                </Card>
              </Col>
              <Col align="center">
                <Card className="shadow" style={{ width: '18rem', border: "none" }}>
                  <Card.Img variant="top" src={pro} />
                  <Card.Body>
                    <Card.Title style={{ fontSize: '25px' }}>$150/mo</Card.Title>
                    {/* <Card.Text style ={{ color: "gray"}}>
                  Pro
                </Card.Text> */}
                    <Card.Text>
                      <ListGroup className="list-group-flush">
                        <ListGroupItem>Access to all features</ListGroupItem>
                        <ListGroupItem>200 Transactions/month</ListGroupItem>
                        <ListGroupItem>Suggested up to groups of 40</ListGroupItem>
                      </ListGroup>
                    </Card.Text>
                    <a href="/#/contactus"><Button style={{ backgroundColor: "#7698ae", border: 'none' }}>Request a Demo</Button></a>
                  </Card.Body>
                </Card>
              </Col>
              <Col align="center">
                <Card className="shadow" style={{ width: '18rem', border: "none" }}>
                  <Card.Img variant="top" src={enterprise} />
                  <Card.Body>
                    <Card.Title style={{ fontSize: '25px' }}>$400/mo</Card.Title>
                    {/* <Card.Text style ={{ color: "gray"}}>
                  Enterprise
                </Card.Text> */}
                    <Card.Text>
                      <ListGroup className="list-group-flush">
                        <ListGroupItem>Access to all features</ListGroupItem>
                        <ListGroupItem>500 Transactions/month</ListGroupItem>
                        <ListGroupItem>Suggested up to groups of 75</ListGroupItem>
                      </ListGroup>
                    </Card.Text>
                    <a href="/#/contactus"><Button style={{ backgroundColor: "#6EA59A", border: 'none' }}>Request a Demo</Button></a>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="section" id="faqs" style={{ marginTop: '50px' }}>
          <div className="row justify-content-center">
            <div className="col text-center">
              <h3>Frequently Asked Questions</h3>
            </div>
          </div>
          <Container style={{ marginTop: '50px', marginBottom: '70px' }}>
            <Accordion>
              <Card style={{ backgroundColor: '#F8F9FB !important' }}>
                <Accordion.Toggle as={Card.Header} eventKey="0">
                  What is a transaction?
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="0">
                  <Card.Body>A transaction on RoundTable refers to a blockchain transaction which is required in order to deploy any information on the Ethereum blockchain that we currently work with. Some of the transactions on our platform include:
                    <li>Creating a circle</li>
                    <li>Creating a proposal </li>
                    <li>Starting voting </li>
                    <li>Voting on a proposal </li>
                    <li>Ending voting </li>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card style={{ backgroundColor: '#F8F9FB !important' }}>
                <Accordion.Toggle as={Card.Header} eventKey="1">
                  If my circle has more than 75 members, would I still be able to use RoundTable?
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    Yes, please contact us at <a href="mailto:hello@makeroundtable.com?subject=Circle%20for%20more%20than%2075">hello@makeroundtable.com </a>and we will be happy to make a customized plan work for you.
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card style={{ backgroundColor: '#F8F9FB !important' }}>
                <Accordion.Toggle as={Card.Header} eventKey="2">
                  Will I get automatically pushed to a higher tier once I run out of the transactions provided to me by the plan I am using?
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    No. You will be notified once you have run out of all the transactions and asked if you want to move to an upper tier or contact us if you need more than 500 transactions/month. You will also be notified once you only have 20 transactions left regardless of the business plan you select.
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card style={{ backgroundColor: '#F8F9FB !important' }}>
                <Accordion.Toggle as={Card.Header} eventKey="3">
                  If my free trial of 90 days ends before I use up all my transactions, can I still use those transactions?
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="3">
                  <Card.Body>
                    No. Unfortunately, once the 90 days for your free trial is over, you can no longer use our services for free. You can surely transfer your business to a different tier plan as per your needs but your circle will only receive the transactions as allocated by that specific plan as mentioned above.  
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Container>
        </div>
        <SimpleFooter></SimpleFooter>

        {/* <div className='container' style={{ paddingTop: '70px' }}>
        <br/>
      <h1 className="display-2 text-black" style={{
        background: '-webkit-linear-gradient(top right,  #6EA59A, #867fd7)',
        webkitBackgroundClip: 'text',
        webkitTextFillColor: 'transparent',
        fontSize: '50px'
      }}>Pricing page coming soon!</h1>
      <p>Contact us at hello@makeroundtable.com if you are interested in a product demo.</p>
      <br/><br/>
    </div> */}
      </div >
    );
  }
}

export default Pricing;
